import React from "react";
import LoadingScreen from "../components/LoadingScreen";

const SuspenseLoader = () => {
  return <LoadingScreen />;
};

export default SuspenseLoader;
